module.exports = __webpack_public_path__ + "img/963.ba1edb19.png";